<template>
    <div>
      <Table
          :data="resources" 
          :columns="columns" 
          size="small"
          highlight-row
          stripe
          max-height="700"
        >
      </Table>
    </div>
  </template>
  <script>
  
  export default {
    props: {
      row: Object
    },
    data () {
      return {
        loading: false,
        pdf_view: false,
        contract_id: null,
      }
    },
    computed: {
      resources () {
        return this.row.replacement_details
      },
      columns () {
        return [
          {
            title: this.$t('sparePartReplacement.productName'),
            key: 'product_name',
            width: 628
          },
          {
            title: this.$t('sparePartReplacement.uom'),
            key: 'uom_name',
            width: 160
          },
          {
            title: this.$t('sparePartReplacement.quantity'),
            key: 'quantity',
            align: 'center',
            width: 300
          },
          {
            title: this.$t('sparePartReplacement.remark'),
            key: 'remarks',
            width: 450
          }
        ]
      }
    },
    methods: {
      fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('wholesale/replacement/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
      },
    }
  }
  </script>
  